"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGisClient = useGisClient;
const GisClient_1 = require("@juvare/platform-sdk-js/GisClient");
const react_1 = __importDefault(require("react"));
function useGisClient(baseUrl, tokenProvider) {
    return react_1.default.useMemo(() => new GisClient_1.GisClient(baseUrl, tokenProvider), [baseUrl, tokenProvider]);
}
